// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createEvent } from "effector";
import { ThematicDossierInfoResponseDTO } from "../../api/backend-openapi";

export const setThematicDossiers = createEvent<
  ThematicDossierInfoResponseDTO[]
>("SET_THEMATIC_DOSSIERS");
export const addThematicDossier = createEvent<ThematicDossierInfoResponseDTO>(
  "ADD_THEMATIC_DOSSIER"
);
export const deleteThematicDossier = createEvent<string>(
  "DELETE_THEMATIC_DOSSIER"
);
export const updateThematicDossier = createEvent<
  ThematicDossierInfoResponseDTO
>("UPDATE_THEMATIC_DOSSIER");
